import {
    USER_LIST, GET_USER_PERMISSIONS, ADD_USER_PERMISSIONS, UPDATE_USER_PERMISSIONS, 
    DELETE_USER_PERMISSIONS, GET_FUNCTION_LIST, 
    GET_USER_MODULE_PERMISSIONS, UPDATE_USER_MODULE_PERMISSIONS
} from './../actions/ActionTypes';
import InitialState from './InitialState';


const ManageUserReducer = (state = InitialState.user, action) => {
    switch (action.type) {
        case USER_LIST: {
            let data = {...state};

            data.userListData =  action.userListData;
            data.accessLevel = action.accessLevel;
            data.department = action.department.data.department;
            data.job = action.job.data.job_title;
            return data;
        }
        case GET_FUNCTION_LIST: {
            let functionList = [...action.response];
            return {...state, functionList};
        }
        case GET_USER_PERMISSIONS: {
            let permissionList = [...action.response];
            return {...state, permissionList};
        }
        case ADD_USER_PERMISSIONS: {
            let permissionList = [...state.permissionList, ...action.response];
            return {...state, permissionList};
        }
        case UPDATE_USER_PERMISSIONS: {
            let permissionList = state.permissionList.map(permission => {
                if (permission.id === action.response.id) {
                    return {...action.response};
                }
                return {...permission};
            });
            return {...state, permissionList};
        }
        case DELETE_USER_PERMISSIONS: {
            let permissionList = state.permissionList.filter(permission => 
                permission.id !== action.permission.id
            );
            return {...state, permissionList};
        }
        case GET_USER_MODULE_PERMISSIONS:
            let modulePermissions = [...action.response];
            return {...state, modulePermissions};

        case UPDATE_USER_MODULE_PERMISSIONS:
            let modulePermissionList = state.modulePermissions.map(permission => {
                if (permission.id === action.response.id) {
                    return {...action.response};
                }
                return {...permission};
            });
            let permissionList = [...state.permissionList];
            if (!action.response.show) {
                permissionList = state.permissionList.map(permission => {
                    if (permission.category_id === action.response.function_category) {
                        return {
                            ...permission,
                            can_view: false,
                            can_add: false,
                            can_edit: false,
                            can_delete: false
                        }
                    }
                    return {...permission}
                });
            }
            return {
                ...state, 
                modulePermissions: modulePermissionList,
                permissionList
            };

        default:
            return state;
    }
};
export default ManageUserReducer;



// WEBPACK FOOTER //
// ./src/reducers/ManageUserReducer.js